import { ComponentProps } from 'react';

export const MAIN_ELEMENT_ID = 'main-content';

type MainProps = Omit<ComponentProps<'main'>, 'id' | 'tabIndex'>;

export default function Main(props: MainProps) {
  return <main id={MAIN_ELEMENT_ID} tabIndex={-1} {...props} />;
}
